export default "__VITE_ASSET__CTVyzUIy__"